const MINUTES_IN_DAY = 24 * 60;

const startOfDay = (date: Date): Date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

const minutesOfDay = (date: Date): number =>
  date.getHours() * 60 + date.getMinutes();

/**
 * The part of a booking that falls on `date`, in minutes from that day's 00:00
 * (wall clock). A booking that started the day before begins at 0, one that
 * runs past midnight ends at 1440, so full-day blocks cover the whole day.
 * Null when the booking does not touch the day.
 */
export const getBookingMinutesOnDate = (
  booking: { startTime: string; endTime: string },
  date: Date,
): { start: number; end: number } | null => {
  const dayStart = startOfDay(date);
  const nextDayStart = new Date(
    dayStart.getFullYear(),
    dayStart.getMonth(),
    dayStart.getDate() + 1,
  );
  const bookingStart = new Date(booking.startTime);
  const bookingEnd = new Date(booking.endTime);

  if (bookingStart >= nextDayStart || bookingEnd <= dayStart) {
    return null;
  }

  return {
    start: bookingStart < dayStart ? 0 : minutesOfDay(bookingStart),
    end: bookingEnd >= nextDayStart ? MINUTES_IN_DAY : minutesOfDay(bookingEnd),
  };
};
